import { IRegistrantDetails } from './../../../models/registration/registrantDetails';
import { getRegistrationState } from './registration.selectors';
import { createSelector } from "@ngrx/store";
import { IRegistrationState } from "../../state/registration.state";
import { registrantAdapter } from '../../state/registrants.state';
import { Dictionary } from '@ngrx/entity';

export const getRegistrantsState = createSelector(
    getRegistrationState,
    (state: IRegistrationState) => state.registrants
);

export const {
    selectIds: getRegistrantIds,
    selectAll: getAllRegistrants,
    selectEntities: getRegistrantEntities
} = registrantAdapter.getSelectors(getRegistrantsState);

export const selectRegistrantById = (id: number) => createSelector(
    getRegistrantEntities,
    (registrants: Dictionary<IRegistrantDetails>) => registrants[id] || null
);

export const selectRegistrantIds = getRegistrantIds;

export const selectRegistrants  = createSelector(
    getRegistrantIds,
    getRegistrantEntities,
    (ids: number[], entities) => ids.map(e => entities[e])
);

export const selectFirstRegistrantName = createSelector(
    selectRegistrants,
    (registrants) => registrants.length > 0 ? registrants[0].personalDetails.fullName : null
);
